import styled from 'styled-components';

export const Container = styled.div`
    background-color: var(--color-black);
    margin-top: 35px;
    margin-bottom: 35px;
`;
export const SubTitle = styled.div`
    span {
        color: var(--color-gray);
    }

    h4 {
        color: var(--color-yellow);
    }
`;
